import { formatMoney, parseMoney, parseQuantity, parseRate } from '@fsp/core';
import type { FormEvent } from 'react';

/** Reads a form into plain strings (trimmed). */
export function readForm(event: FormEvent<HTMLFormElement>): Record<string, string> {
  event.preventDefault();
  const out: Record<string, string> = {};
  new FormData(event.currentTarget).forEach((value, key) => { out[key] = typeof value === 'string' ? value.trim() : ''; });
  return out;
}

/** "1 234,56" → cents; empty → 0. Throws on text that is not an amount (the API would refuse it anyway). */
export const cents = (text: string | undefined): number => (text ? parseMoney(text) : 0);
/** While typing ("12,"): null instead of an error, for checks during rendering. */
export const centsOrNull = (text: string | undefined): number | null => { try { return cents(text); } catch { return null; } };
export const milli = (text: string | undefined): number => (text ? parseQuantity(text) : 0);
export const basisPoints = (text: string | undefined): number => (text ? parseRate(text) : 0);

/** Cents → "1234,56" for an input field (no currency sign, no grouping). */
export const moneyInput = (value: number | null | undefined): string => (value === null || value === undefined ? '' : (value / 100).toFixed(2).replace('.', ','));
export const rateInput = (bp: number | null | undefined): string => (bp === null || bp === undefined ? '' : String(bp / 100).replace('.', ','));
export const quantityInput = (m: number): string => String(m / 1000).replace('.', ',');
export const money = (value: number, currency = 'EUR') => formatMoney(value, currency);

export const nullIfEmpty = (value: string | undefined): string | null => (value ? value : null);
